/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { useMutation } from 'react-query';

import { OrganizationApiService } from '../../services/OrganizationApiService';
import { EntityId } from '../../types/api/EntityId';
import { UpdateOrganizationRequest } from '../../types/organization/UpdateOrganizationRequest';
import { reactToUpdateOrganization } from '../../utils/reactions';

export const useUpdateOrganization = (awaitForReaction: boolean) => {
  return useMutation(
    ({ organizationId, data }: { organizationId: EntityId; data: Partial<UpdateOrganizationRequest> }) => {
      return OrganizationApiService.updateOrganizationById(organizationId, data);
    },
    {
      onSettled: async (_data, _error, variables) => {
        awaitForReaction
          ? await reactToUpdateOrganization({ ...variables })
          : void reactToUpdateOrganization({ ...variables });
      },
      onError: e => {
        throw e;
      },
    },
  );
};
